import { getToken, clearSession } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

// Sisipkan header Authorization dari token tersimpan (jika ada).
function authHeaders(extra = {}) {
  const token = getToken();
  return { ...extra, ...(token ? { Authorization: `Bearer ${token}` } : {}) };
}

// Token kadaluarsa / tidak valid → bersihkan sesi & muat ulang ke halaman login.
function ensureAuthorized(res) {
  if (res.status === 401) {
    clearSession();
    window.location.reload();
    throw new Error('Sesi berakhir, silakan login kembali');
  }
}

export async function fetchFilters() {
  const res = await fetch(`${API_URL}/api/filters`, { headers: authHeaders() });
  ensureAuthorized(res);
  if (!res.ok) throw new Error(`Server error ${res.status}`);
  return res.json();
}

export async function fetchSalesmanByDistributor(distributorIds) {
  const param = distributorIds.length > 0 ? distributorIds.join(',') : '';
  const res = await fetch(`${API_URL}/api/salesman?distributor_ids=${encodeURIComponent(param)}`, {
    headers: authHeaders(),
  });
  ensureAuthorized(res);
  if (!res.ok) throw new Error(`Server error ${res.status}`);
  return res.json();
}

export async function fetchDashboardData(params) {
  const res = await fetch(`${API_URL}/api/dashboard`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(params),
  });

  ensureAuthorized(res);
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`Server error ${res.status}${text ? ': ' + text : ''}`);
  }

  return res.json();
}
